import React from 'react';

const ProgressBar = ({ progressBarRef, playerRef, timeProgress, duration, formatTime }) => {

    const handleProgressChange = () => {
        playerRef.current.currentTime = progressBarRef.current.value;
    };

    return (
        <div className="flex items-center gap-1 text-sm text-pod-light">
            <div>{ formatTime(timeProgress) }</div>

            <div className="flex-1 flex items-center bg-pod-light">
                <input
                    className="audio-range"
                    type="range"
                    ref={ progressBarRef }
                    defaultValue="0"
                    onChange={ handleProgressChange }
                />
            </div>

            <div>{ formatTime(duration) }</div>
        </div>
    );
};
export default ProgressBar;